import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import WhatsAppChatWidget from "./WhatsAppChatWidget";

// Project data — image + elaborated description for each work
const projects = [
  {
    image: "./assets/img/about-lucas.jpeg",
    title: "Lucas Bridge MS Fencing Works",
    description:
      "We executed a complete mild steel fencing installation along Lucas Bridge, designed to safeguard pedestrians and vehicles while withstanding constant traffic vibration and outdoor exposure. Every panel was fabricated with precision welding and finished with a weather-resistant coating, combining structural strength with a clean, modern appearance that complements the bridge's surroundings.",
  },
  {
    image: "./assets/img/about-vadapalani.jpeg",
    title: "Vadapalani Metro Bridge Garden MS Fencing Works",
    description:
      "This project involved fabricating and installing mild steel garden fencing around the Vadapalani Metro Bridge landscaped area. The design balances safety and aesthetics, protecting the green space while allowing an open, unobstructed view. Rust-resistant treatment was applied throughout to ensure long-term durability in a high footfall urban environment.",
  },
  {
    image: "./assets/img/about-vandalur.jpeg",
    title: "Vandalur Bridge MS Fencing",
    description:
      "Our team engineered a heavy-duty mild steel fencing system for Vandalur Bridge, built to handle the demands of a busy transit corridor. The fabrication focused on structural rigidity, secure anchoring, and a uniform finish, delivering a safety barrier that meets government infrastructure standards without compromising visual appeal.",
  },
  {
    image: "./assets/img/about-annanagar-lucas.jpeg",
    title: "Anna Nagar to Lucas Bridge Garden MS Fencing",
    description:
      "Spanning the stretch from Anna Nagar to Lucas Bridge, this garden fencing project was designed to protect the landscaped corridor while maintaining an inviting, open feel for pedestrians. We used custom-fabricated mild steel sections, finished for corrosion resistance, to create a cohesive and durable boundary along the entire route.",
  },
  {
    image: "./assets/img/about-kanchiwaram.jpeg",
    title: "Kanchiwaram Bridge Top Handrails Works",
    description:
      "For Kanchiwaram Bridge, we designed and installed top handrail systems engineered for maximum pedestrian safety at height. Each handrail was fabricated with reinforced joints and securely anchored to the bridge structure, then finished to resist weathering — delivering a dependable safety solution built to last for years of public use.",
  },
];

const IronSteel = () => {
  const pageTitle =
    "Iron & Steel Projects - VishuShethra Industries | Bridge Fencing & Handrail Works";
  const pageDescription =
    "Explore VishuShethra Industries' iron and steel project portfolio — MS fencing and handrail works completed across Lucas Bridge, Vadapalani Metro, Vandalur, Anna Nagar, and Kanchiwaram bridges.";
  const pageUrl = "https://vishushethra.com/iron-and-steel";

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href={pageUrl} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
      </Helmet>

      {/* Banner Section */}
      <div className="banner-section">
        <img
          src="./assets/img/bannerbreadcrumbs.png"
          alt="Banner"
          className="img-fluid banner-img"
        />
        <div className="breadcrumb-container">
          <h2>Iron &amp; Steel</h2>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Iron &amp; Steel
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Intro */}
      <div className="container py-5">
        <h2 className="text-center mb-3">Iron &amp; Steel Works</h2>
        <p className="text-center text-justify mx-auto" style={{ maxWidth: "800px" }}>
          Take a look at some of our completed iron and steel fabrication
          projects — from bridge fencing to protective handrails — each built
          with the same commitment to durability, safety, and craftsmanship
          that defines every VishuShethra Industries project.
        </p>
      </div>

      {/* Projects Grid */}
      <div className="container pb-5">
        <div className="row">
          {projects.map((project, index) => (
            <div className="col-md-6 mb-5" key={index}>
              <div className="card h-100 shadow border-0">
                <img
                  src={project.image}
                  alt={project.title}
                  className="card-img-top"
                  style={{ objectFit: "cover", height: "320px" }}
                />
                <div className="card-body p-4">
                  <h4 className="card-title mb-3">{project.title}</h4>
                  <p className="card-text text-justify">
                    {project.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <WhatsAppChatWidget
        phoneNumber="+919488828030"
        companyName="VishuShethra Industries"
      />
    </>
  );
};

export default IronSteel;